/* tslint:disable */

declare var Object: any;
export interface ERPshippingInstructionInterface {
  "id"?: number;
}

export class ERPshippingInstruction implements ERPshippingInstructionInterface {
  "id": number;
  constructor(data?: ERPshippingInstructionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPshippingInstruction`.
   */
  public static getModelName() {
    return "ERPshippingInstruction";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPshippingInstruction for dynamic purposes.
  **/
  public static factory(data: ERPshippingInstructionInterface): ERPshippingInstruction{
    return new ERPshippingInstruction(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPshippingInstruction',
      plural: 'ERPshippingInstructions',
      path: 'ERPshippingInstructions',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPshippingInstruction.ts